import { roundDecimals as d, SizeBasedOnChildren as l } from "@project-rouge/rg-core";
import { Vector3 as a } from "three";
import { affectsParent as h } from "../affects-parent/index.js";
import { isRgMesh as A } from "../rg-render-types/index2.js";
import { isRgView as y } from "../rg-render-types/index4.js";
import { resizeBasedOnChildren as D } from "./index.js";
function C(r, n, p) {
  if (p) {
    const c = new a().fromArray(r.userData.size), f = new a().fromArray(r.userData.anchor), m = new a().fromArray(n);
    for (const t of r.children) {
      if (A(t))
        continue;
      const s = t.position.add(c.clone().multiply(f.clone().sub(m))), i = s.toArray().map((u) => d(u, 3));
      s.fromArray(i), t.userData.pos = i;
    }
  }
  const o = { ...r.userData, anchor: n };
  r.userData = o, r.updateGeo(), h(r) && r.parent.updateGeo();
  let e = r.parent;
  for (; e && y(e); )
    l.includes(e.userData.type) && D(e), e = e.parent;
  Object.assign(r.userData, o);
}
export {
  C as updateViewAnchor
};
//# sourceMappingURL=index3.js.map
